{
  "title": "Anfragen",
  "subtitle": "Nachrichten vom öffentlichen Kontaktformular und von Hilfe holen im Portal.",
  "newCount": "{{count}} neu",
  "statusNew": "Neu",
  "statusHandled": "Bearbeitet",
  "statusSpam": "Spam",
  "loadError": "Anfragen konnten nicht geladen werden",
  "goneTitle": "Diese Anfrage ist weg",
  "goneBody": "Der Link zeigte auf eine Anfrage, die nicht mehr hier ist — sie wurde möglicherweise entfernt, oder die Adresse war falsch.",
  "emptyNewTitle": "Nichts wartend",
  "emptyNewBody": "Alles Wartende wurde erledigt.",
  "emptyOtherTitle": "Nichts hier",
  "emptyOtherBody": "Keine Anfragen mit Status {{status}}.",
  "handledBy": "bearbeitet von {{name}}",
  "reply": "Antworten",
  "markHandled": "Als bearbeitet markieren",
  "markSpam": "Spam",
  "markNew": "Wieder öffnen",
  "markedVerb": "{{name}} als {{verb}} markiert.",
  "updateError": "Diese Anfrage konnte nicht aktualisiert werden.",
  "replyTitle": "Antwort an {{name}}",
  "replyBody": "Ihre Antwort",
  "sendReply": "Antwort senden",
  "replySent": "Antwort an {{email}} gesendet.",
  "replyError": "Diese Antwort konnte nicht gesendet werden.",
  "getHelp": "Hilfe holen",
  "getHelpTitle": "Hilfe holen",
  "getHelpHint": "Sagen Sie uns, was Sie brauchen. Das OnBrand-Mail-Team antwortet per E-Mail.",
  "messageLabel": "Nachricht",
  "messagePlaceholder": "Was Sie versuchen zu tun, und was dem im Weg steht.",
  "send": "Senden",
  "helpSent": "Nachricht gesendet. Wir antworten per E-Mail.",
  "helpRateLimited": "Mehrere Nachrichten in kurzer Zeit — versuchen Sie es in ein paar Minuten erneut.",
  "helpSendError": "Senden fehlgeschlagen. Bitte erneut versuchen.",
  "noAccessTitle": "Kein Zugriff auf Anfragen",
  "noAccessBody": "Nachrichten von der öffentlichen Website liest das OnBrand-Mail-Team.",
  "footerNote": "Anfragen kommen vom Kontaktformular der öffentlichen Website und von Hilfe holen im Portal. Website-Nachrichten sind noch keine Kunden — ein Mandant wird auf dem Bildschirm Mandanten angelegt, sobald es etwas einzurichten gibt. Die Portal-Hilfe benennt bereits die Organisation.",
  "replySendsFrom": "Sendet von OnBrand Mail an {{email}}. Ihre Antwort kommt zurück in den Support-Posteingang.",
  "verbHandled": "erledigt",
  "verbSpam": "Spam",
  "verbReopened": "wieder neu"
}
